<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "NakedIndex"
}
</script>

<style scoped>

</style>
